const STORAGE_KEY = "dashboard_access_session";

export interface DashboardSession {
  accessToken: string;
  parentToken: string;
  userId: string;
  userLabel: string;
}

export function getDashboardSession(): DashboardSession | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "null");
    return value?.accessToken && value?.parentToken && value?.userId ? value : null;
  } catch {
    return null;
  }
}

export function getSessionToken(): string | null {
  const view = getDashboardSession();
  const parentToken = localStorage.getItem("token");
  // Never send the picker credential from a page still displaying a customer's data.
  return view ? (view.parentToken === parentToken ? view.accessToken : null) : parentToken;
}

export function saveDashboardSession(session: DashboardSession): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function returnToUsers(): void {
  const view = getDashboardSession();
  sessionStorage.removeItem(STORAGE_KEY);
  const query = view ? `?user=${encodeURIComponent(view.userId)}` : "";
  // A full navigation also disposes queries, sockets and stores from the customer.
  window.location.replace(`/dashboard-access/users${query}`);
}

export function handleSessionExpired(): void {
  if (getDashboardSession()) {
    returnToUsers();
  } else {
    localStorage.removeItem("token");
    window.location.replace("/login");
  }
}
